import { ThunderDispatcher } from '@nu-art/thunderstorm-frontend/index';
export const dispatch_FloatingWindows_WindowsUpdated = new ThunderDispatcher('__onFloatingWindowsUpdated');
//# sourceMappingURL=models-updated.js.map